import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ServiceOrder } from './serviceOrder';
import { ServiceOrderService } from './serviceOrder.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { Store } from 'app/store/store';
import { StoreService } from 'app/store/store.service';
import { Status } from 'app/status/status';
import { HttpParams } from '@angular/common/http';

@Component({
	template: `
		<h3 class="title" i18n="@@create-serviceOrder">Create Service Order</h3>

		<form *ngIf="form" [formGroup]="form" (ngSubmit)="create()">
			<fieldset class="fieldset">
				<legend class="legend" i18n="@@data-machine">Service Order data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="store" i18n="@@store">Branch</label>
						<mat-select [formControl]="form.controls['store']" [compareWith]="compareFn" disableRipple>
							<mat-option i18n="@@select-none">None</mat-option>
							<mat-option *ngFor="let opt of stores" [value]="opt">{{opt.name}}</mat-option>
						</mat-select>
						<validator [control]="form.controls['store']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="description" i18n="@@description">Description</label>
						<textarea formControlName="description"></textarea>
					</div>
				</div>
			</fieldset>

			<div class="options">
				<button class="btn-text" type="submit" [disabled]="!form.valid">
					<span i18n="@@option-save">Save</span>
				</button>
			</div>
		</form>
	`
})
export class ServiceOrderCreateComponent implements OnInit {
	form: FormGroup;
	stores: Store[];

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private serviceOrderService: ServiceOrderService,
		private storeService: StoreService,
		private notificationService: NotificationService,
	) {
		let serviceOrder = new ServiceOrder();
		serviceOrder.statusServiceOrder = new Status('so_revision');
		this.form = this.serviceOrderService.toFormGroup(serviceOrder);
	}

	ngOnInit() {
		this.storeService.getAll(
			new HttpParams().set('sort', 'name').set('collection', 'id, name')
		).subscribe(data => {
			this.stores = data['result'];
		});
	}

	create() {
		this.serviceOrderService.create(<ServiceOrder> this.form.value).subscribe(serviceOrder => {
			this.notificationService.sucessInsert(serviceOrder.id.toString());
			this.router.navigate([`../${serviceOrder.id}`], {relativeTo: this.activatedRoute});
		}, err => this.notificationService.error(err));
	}

	compareFn(c1: any, c2: any): boolean {
		return c1 && c2 ? c1.id === c2.id : c1 === c2;
	}
}
